export const extend = function () {
  const extended = {}
  let deep = false
  let i = 0
  const length = arguments.length

  // Check if a deep merge
  if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
    deep = arguments[0]
    i++
  }

  // Merge the object into the extended object
  const merge = function (obj) {
    for (const prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        // If deep merge and property is an object, merge properties
        if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
          extended[prop] = extend(true, extended[prop], obj[prop])
        } else {
          extended[prop] = obj[prop]
        }
      }
    }
  }

  // Loop through each object and conduct a merge
  for (;i < length; i++) {
    const obj = arguments[i]
    merge(obj)
  }

  return extended
}

export const $ = function (selector, parent) {
  return (parent || document).querySelector(selector)
}

export const $$ = function (selector, parent) {
  return [...(parent || document).querySelectorAll(selector)]
}

export const offset = function (element) {
  if (element) {
    const offset = element.getBoundingClientRect()

    return {
      top: offset.top + window.scrollY,
      left: offset.left + window.scrollX
    }
  }

  return false
}

export const addEvent = function (element, event, handler) {
  const customEvent = new Event(event)

  element.addEventListener(event, handler)

  return customEvent
}

export const removeEvent = function (element, type, handler) {
  if (element.detachEvent) {
    element.detachEvent('on' + type, handler)
  } else {
    element.removeEventListener(type, handler)
  }
}

export const hasParentsClass = function (element, classname) {
  if (element.classList.contains(classname)) {
    return true
  }

  return element.parentElement && hasParentsClass(element.parentElement, classname)
}

export const hasParentsDataset = function (element, dataName) {
  if (element.dataset[dataName]) {
    return true
  }

  return element.parentElement && hasParentsDataset(element.parentElement, dataName)
}

export const jumpToElement = function (element, offsetY = 200) {
  if (element) {
    const elementOffset = offset(element)

    window.scrollTo({
      top: elementOffset.top - offsetY,
      behavior: 'smooth'
    })
  }
}
